<template>
	<div class="hello">
		<RobotSocket ref="robotSocket" :nowTime='nowTime' @backSockertData='doSocker($event)' />
		<Head type='index' @tapStatus="changeTap($event)" @out='headOut($event)'></Head>
		<el-dialog :visible.sync="dialogVisible" width="20%" center>
			<div style="width: 100%;height: 100%;position: relative;">
				<img style="width: 100%;height: 100%;" src="../../../../static/imgV2/robotImg.png" alt="">
				<div
					style="position: absolute;width: 100%;top: 30%;font-size: 1.2vw;color: white;font-weight: 600;text-align: center;">{{ languageJson.ExitText }}</div>
				<div
					style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
					<el-button type="primary" style="width: 40%;font-size: 1vw;padding: 0.5vw 0;" @click="dialogVisible = false">{{ languageJson.Cancel }}</el-button>
					<el-button type="danger" style="width: 40%;font-size: 1vw;padding: 0.5vw 0;" @click="getOut()">{{ languageJson.Exit }}</el-button>
				</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="ifEvent" width="50%" center>
			<div style="width: 100%;height: 100%;position: relative;">
				<img :src="evetObj.imgUrl" style="width: 100%;height: 100%;" alt="">
			</div>
		</el-dialog>

		<div class="indeBody">
			<div class="indeBody-left">
				<div
					style="width: 100%;height: 100%;display: flex;flex-direction: column;justify-content: space-between;">
					<div class="leftTopUl" :style="{backgroundImage: 'url(' + topBack + ')'}">
						<LeftTop :changeTime='changeTime' style="z-index: 999;"></LeftTop>

						<div class="inFloorDom" v-if="robotType == '04' || robotType == '05' || robotType == '06' || robotType == '07'">
							<div class="inFloorDom-top" @click="mapFloorScroll('left')">
								<img :src="mapTopIcon" @mouseenter="mapTopIcon = mapTopIcon_C" @mouseleave="mapTopIcon = mapTopIcon_N" style="width: 0.7vw;" alt="">
							</div>
							<div class="inFloorDom-center">
								<div v-for="(obj, $index) in indoorMap" :key="$index" :class="obj.floor == checkFloor.floor ? 'inFloorDom-check' : 'inFloorDom-li'" @click="setFloorMap(obj)">
									<img v-if="obj.floor == checkFloor.floor" :src="mapCenter" style="width: 3.2vw;position: absolute;right: 0;top: 0;" alt="">
									<div style="z-index: 99;font-weight: 700;margin-top: -5%;">{{ obj.floorName }}</div>
								</div>
							</div>
							<div class="inFloorDom-bottom" @click="mapFloorScroll('right')">
								<img :src="mapBottomIcon" @mouseenter="mapBottomIcon = mapBottomIcon_C" @mouseleave="mapBottomIcon = mapBottomIcon_N" style="width: 0.7vw;" alt="">
							</div>
						</div>

						<img class="floorImg" style="top: 45%;" :src="search" @mouseenter="search = searchMapCheck" @mouseleave="search = searchMap" alt="" @click="ifMapList = !ifMapList">
						<img v-if="(robotType == '04' || robotType == '05' || robotType == '06' || robotType == '07') && ifOpen3dIndex == 0" class="floorImg" :src="checkFloorImage" @mouseenter="checkFloorImage = checkFloorImageMapCheck" @mouseleave="checkFloorImage = checkFloorImageMap" alt="" @click="open3D()">
						<img v-if="(robotType == '04' || robotType == '05' || robotType == '06' || robotType == '07') && (ifOpen3dIndex == 1 || ifOpen3dIndex == 2)" class="floorImg" :src="backFloorImage" @mouseenter="backFloorImage = backFloorImageMapCheck" @mouseleave="backFloorImage = backFloorImageMap" alt="" @click="back3D()">

						<transition name="el-zoom-in-left">
							<div class="d3Class" v-if="ifOpen3d">
								<img src="../../../../static/imgV2/3dBackground.png" style="width: 100%;height: 100%;" alt="">
								<img :src=" ifOpen3dIndex == 2 ? '../../../../static/imgV2/jzbj1.png' : '../../../../static/imgV2/jzbj2.png' " :class=" ifOpen3dIndex == 2 ? 'd3Class-background d3Floor' : 'd3Class-background' " alt="">
								<div class="d3Class-floor" :style="{left: ifOpen3dIndex == 2 ? '20%':'45%'}">
									<img :src="ifOpen3dIndex == 2 ? building : buildingCheck" :style="{height: '100%',cursor: ifOpen3dIndex == 2 ? 'pointer' : 'inherit'}" @click="buildCheck" alt="">
									<transition name="el-zoom-in-left">
										<div v-if="ifOpen3dIndex != 2" class="d3Class-floor-ul">
											<div class="floor-li" v-for="(obj, $index) in allFloorAry" :key='$index' :style="{top: `${obj.top}%`,left: `${obj.left}vw`}">
												<img class="floor-li-line" src="../../../../static/imgV2/mapRouter.png" :style="{width: `${4.5-obj.left}vw`}" alt="">
												<div class="floor-li-img" @click="floorCheck(obj)">
													<div class="floor-li-text">{{obj.name}}</div>
													<img style="width: 100%;" src="../../../../static/imgV2/loucengbutton.png" alt="">
												</div>
											</div>
										</div>
									</transition>
								</div>

								<transition name="el-zoom-in-left">
									<div v-if="ifOpen3dIndex == 2" class="swiperDom">
										<div class="swiper mySwiper">
											<div class="swiper-wrapper">
												<div class="swiper-slide" floorID="top" style="opacity: 0;">
													<div></div>
												</div>
												<div class="swiper-slide" v-for="(obj, $index) in indoorMap" :key='$index' :floorID="obj.floor">
													<div class="floorButtonCheck">{{ obj.floorName }}</div>
													<div style="height: 100%;" :class="checkRobotFloor.includes(obj.floor) ? 'floorMapRobot' : 'floorMapCheck' "></div>
												</div>
												<div class="swiper-slide" floorID="bototm" style="opacity: 0;">
													<div></div>
												</div>
											</div>
										</div>
									</div>
								</transition>
							</div>
						</transition>

						<transition name="el-zoom-in-bottom">
							<div v-show="ifMapList" class="ifMapListVos">
								<img src="../../../../static/imgV2/closeIcon.png" @click="ifMapList = false" style="position: absolute;top: 0.5vw;right: 0.5vw;width: 1.5vw;height: 1.5vw;z-index: 99;cursor: pointer;" alt="">
								<img v-if="mapAry.length > 6" class="mapLeft" src="../../../../static/imgV2/leftCheck.png" @click="mapScroll('left')" alt="">
								<img v-if="mapAry.length > 6" class="mapRight" src="../../../../static/imgV2/rightCheck.png" @click="mapScroll('right')" alt="">
								<div class="mapDom">
									<div class="mapDomLi" v-for="(obj, $index) in mapAry" :key="$index" @click="setCheckMap(obj, 'click')">
										<div class="mapDomLiTitle">
											<span>{{ obj.routeName }}</span>
											<span>{{ obj.routeType == '1' ? languageJson.indoor : languageJson.outdoor }}</span>
										</div>
										<div class="mapDomLiBody" :style="{'border': obj.routeNumber == checkMapNumber ? '2px solid #3f87fd' : '2px solid #000D3F'}">
											<img :src="obj.routeImg" :class=" obj.routeNumber == checkMapNumber ? 'img-li' : 'img-li img-check' " alt="">
										</div>
									</div>
								</div>
							</div>
						</transition>
						<div ref="autoHeight" class="autoHeight">
							<div id="exampleDom" v-if="!ifOpen3d">
								<div class="exli">
									<img src="../../../../static/imgV2/site1.gif">
									<span :style="{ 'width' : languageCheck == 'English' ? '4vw' : ''}">&nbsp;{{ languageJson.Inspection }}</span>
								</div>
								<div class="exli">
									<img src="../../../../static/imgV2/site2.gif">
									<span :style="{ 'width' : languageCheck == 'English' ? '4vw' : ''}">&nbsp;{{ languageJson.charge }}</span>
								</div>
								<div class="exli">
									<img src="../../../../static/imgV2/site3.gif">
									<span :style="{ 'width' : languageCheck == 'English' ? '4vw' : ''}">&nbsp;{{ languageJson.offline }}</span>
								</div>
								<div class="exli">
									<img src="../../../../static/imgV2/site4.gif">
									<span :style="{ 'width' : languageCheck == 'English' ? '4vw' : ''}">&nbsp;{{ languageJson.fault }}</span>
								</div>
							</div>
							<div v-if="!ifOpen3d" class="content-div-check"
								:style="{ width: vWidth + 'px', height: vHeight + 'px', zoom: mapScale}">
								<img :src="backUrl" />
								<div class="robot_li" ref="robot" v-for="(obj, index) in mapRobotAry" :key="index" @click="getRobot(obj, index)" style="cursor: pointer;">
									<img v-if="obj.robotIconStatus == '0' || obj.robotIconStatus == '1'" src="../../../../static/imgV2/site1.gif">
									<img v-else-if="obj.robotIconStatus == '2'" src="../../../../static/imgV2/site2.gif">
									<img v-else-if="obj.robotIconStatus == '3'" src="../../../../static/imgV2/site3.gif">
									<img v-else-if="obj.robotIconStatus == '5'" src="../../../../static/imgV2/site4.gif">
								</div>
								<div ref="flvDom" v-if="checkFlvDom" class="checkFlvClass">
									<img style="position: absolute;width: 100%;height: 100%;left: 0;top: 0;" src="../../../../static/imgV2/robotImg.png" alt="">
									<span ref="zoomSpan" style="color: white;font-size: 0.8vw;position: absolute;top: 0.6vw;left: 0.5vw;">{{checkInfo.robotName}}</span>
									<div ref="zoomImage" style="position: absolute;cursor: pointer;top: 6%;right: 2%;width: 1.5vw;height: 1.5vw;">
										<img src="../../../../static/imgV2/closeIcon.png" style="width: 100%;height: 100%;" @click="checkFlvDom = false" alt="">
									</div>
									<div style="position: absolute;width: 100%;height: 79%;bottom: 2px;left: 0;" @click="toDetail(checkInfo)">
										<RobotFlv :playStatus='true' :ststus='checkInfo.ststus' :rid='checkInfo.robotId' :rtmpSrc='checkInfo.flvPtz'/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div style="width: 100%;height: 32%;display: flex;justify-content: space-between;">
						<div
							:style="{backgroundImage: 'url(' + topSmall + ')',width: '33%',height: '100%', backgroundSize: '100% 100%'}">
							<LeftBottomLeft :changeTime='changeTime'></LeftBottomLeft>
						</div>
						<div
							:style="{backgroundImage: 'url(' + wbrtcBg + ')',width: '65%',height: '100%', backgroundSize: '100% 100%'}">
							<LeftBottomRight @eventMap='showMap($event)' :changeTime='changeTime'></LeftBottomRight>
						</div>
					</div>
				</div>
			</div>
			<div class="indeBody-right">
				<div :style="{backgroundImage: 'url(' + topSmall + ')'}" class="indeBody-right-item">
					<RightTop :changeTime='changeTime' :timeStamp="timeStamp" style="height: 100%;"></RightTop>
				</div>
				<div :style="{backgroundImage: 'url(' + topSmall + ')'}" class="indeBody-right-item">
					<RightCenter :mapType='robotType' :floor='checkFloor.floor' :routeId='checkMapId' :changeTime='changeTime' :timeStamp="timeStamp" style="height: 100%;"></RightCenter>
				</div>
				<div :style="{backgroundImage: 'url(' + topSmall + ')'}" class="indeBody-right-item">
					<RightBottom :changeTime='changeTime' :timeStamp="timeStamp"></RightBottom>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getItem,
		setToken,
		setItem,
		removeItem,
		removeToken,
	} from '@/utils/auth'
	import {
		positonList,
		robotDetail,
		tenantInfoMapRoute
	} from '@/api/indexV2'
	import Head from '@/components/Head.vue'
	import RightTop from '@/page/customIndex/components/rightTop.vue'
	import RightBottom from '@/page/customIndex/components/rightBottom.vue'
	import LeftBottomLeft from '@/page/customIndex/components/leftBottomLeft.vue'
	import LeftBottomRight from '@/page/customIndex/components/leftBottomRight.vue'
	import LeftTop from '@/page/customIndex/components/leftTop.vue'
	import RightCenter from '@/page/customIndex/components/rightCenter.vue'
	import RobotSocket from '@/components/RobotSocket.vue'
	import RobotMapLi from '@/components/RobotMapLi.vue'
	import RobotFlv from '@/components/flv264V3.vue'
	// import 'swiper.js'
	// import Swiper from 'swiper'

	export default {
		name: 'index',
		components: {
			Head,
			RightTop,
			RightBottom,
			LeftBottomLeft,
			LeftBottomRight,
			LeftTop,
			RightCenter,
			RobotSocket,
			RobotMapLi,
			RobotFlv
		},
		data() {
			return {
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
				allFloorNum: 0,
				allFloorAry: [],
				ifOpen3d: false,
				ifOpen3dIndex: 0,
				selectImg0: require('../../../../static/imgV2/checkSelect-0.png'),
				selectImg1: require('../../../../static/imgV2/checkSelect-1.png'),
				borderBack: require('../../../../static/imgV2/bg.png'),
				topBack: require('../../../../static/imgV2/index-left-top.png'),
				topSmall: require('../../../../static/imgV2/small-bg.png'),
				wbrtcBg: require('../../../../static/imgV2/eventBackImg.png'),
				timeBg: require('../../../../static/imgV2/qietu02.png'),
				search: require('../../../../static/imgV2/searchMap.png'),
				searchMap: require('../../../../static/imgV2/searchMap.png'),
				searchMapCheck: require('../../../../static/imgV2/searchMap-check.png'),
				checkFloorImage: require('../../../../static/imgV2/checkFloor.png'),
				checkFloorImageMap: require('../../../../static/imgV2/checkFloor.png'),
				checkFloorImageMapCheck: require('../../../../static/imgV2/checkFloor-check.png'),
				backFloorImage: require('../../../../static/imgV2/floorBack.png'),
				backFloorImageMap: require('../../../../static/imgV2/floorBack.png'),
				backFloorImageMapCheck: require('../../../../static/imgV2/floorBack-check.png'),
				floorMapImg: require('../../../../static/imgV2/floor-map.png'),
				floorMapImgCheck: require('../../../../static/imgV2/floor-map-check.png'),
				building: require('../../../../static/imgV2/building-op.png'),
				buildingCheck: require('../../../../static/imgV2/building.png'),
				nowTime: new Date().getTime(),
				tapType: false,
				dialogVisible: false,
				timeStamp: 0,
				vHeight: 0,
				vWidth: 0,
				backUrl: '',
				mapRobotAry: [],
				posInfo: {},
				checkMapNumber: '',
				checkMapId: '',
				mapScale: '',
				checkFlvDom: false,
				checkInfo: {
					robotName: '',
					flvPtz: ''
				},
				changeTime: false,
				ifEvent: false,
				ifMapList: false,
				evetObj: {
					imgUrl: "",
					insDate: "",
					name: "",
					positonName: "",
					type: ""
				},
				mapAry: [],
				positonListSetInterval: null,
				robotType: "",
				mapTopIcon: require('../../../../static/imgV2/map-top1.png'),
				mapTopIcon_N: require('../../../../static/imgV2/map-top1.png'),
				mapTopIcon_C: require('../../../../static/imgV2/map-top2.png'),
				mapBottomIcon: require('../../../../static/imgV2/map-bottom1.png'),
				mapBottomIcon_N: require('../../../../static/imgV2/map-bottom1.png'),
				mapBottomIcon_C: require('../../../../static/imgV2/map-bottom2.png'),
				mapCenter: require('../../../../static/imgV2/mapCenter.png'),
				indoorMap: [],
				indoorRobot: [],
				checkFloor: {
					floor: "",
					mapUrl: "",
					floorName: "",
					height: "",
					width: "",
					originX: "",
					originY: "",
					resolution: "",
					routeId: ""
				},
				floorNumber: "",
				checkRobotFloor: [],
				timerClear: null
			}
		},
		mounted() {
			let that = this
			window.onresize = (res) => {
				that.timeStamp = res.timeStamp
			}
			that.timerClear = setInterval(() => {
				that.changeTime = !that.changeTime
			},30000)
			if (!that.positonListSetInterval) {
				setTimeout(() => {
					that.positonListSetInterval = setInterval(() => {
						that.positonList(that.checkMapNumber)
					}, 10000)
				},5000)
			}
			that.getMap()
			// 模拟楼层
			// that.highestFloor()
		},
		destroyed() {
			let that = this
			clearInterval(that.positonListSetInterval)
			clearInterval(that.timerClear)
			that.positonListSetInterval = null
			that.timerClear = null
		},
		updated() {
			let that = this
			if (that.$refs.robot && that.$refs.robot.length > 0) {
				that.$refs.robot.map((v, index) => {
					// document.getElementsByClassName('robot_li')[index].style.width = 60 / Number(that.mapScale) + "px"
					// document.getElementsByClassName('robot_li')[index].style.height = 30 / Number(that.mapScale) + "px"
					// v.style.left = Number(that.mapRobotAry[index].positon.split(',')[0]) - (1.5 / Number(that.mapScale)) + 'vw'
					// v.style.top = Number(that.mapRobotAry[index].positon.split(',')[1]) - (0.75 / Number(that.mapScale)) + 'vw'
					document.getElementsByClassName('robot_li')[index].style.width = 3 / Number(that.mapScale) + "vw"
					document.getElementsByClassName('robot_li')[index].style.height = 1.5 / Number(that.mapScale) + "vw"
					if (that.robotType == "04" || that.robotType == "08" || that.robotType == "09") {
						v.style.left = that.drawPointFun({x: Number(that.mapRobotAry[index].positon.split(',')[0]), y: Number(that.mapRobotAry[index].positon.split(',')[1])})[0] - (30 / Number(that.mapScale)) + 'px'
						v.style.top = that.drawPointFun({x: Number(that.mapRobotAry[index].positon.split(',')[0]), y: Number(that.mapRobotAry[index].positon.split(',')[1])})[1] - (15 / Number(that.mapScale)) + 'px'
					} else {
						v.style.left = Number(that.mapRobotAry[index].positon.split(',')[0]) - (30 / Number(that.mapScale)) + 'px'
						v.style.top = Number(that.mapRobotAry[index].positon.split(',')[1]) - (15 / Number(that.mapScale)) + 'px'
					}
				})
			}
		},
		methods: {
			highestFloor() {
				let that = this;
				that.allFloorAry = []
				for(let i = 0;i < parseInt(that.allFloorNum / 10);i++) {
					that.allFloorAry.push({
						name: !i ? '1F-10F' : `${i}1F - ${i+1}0F`,
						top: !i ? 80 : (80 - i*(70/parseInt(that.allFloorNum / 10))),
						left: !i ? parseInt(that.allFloorNum / 10) * 0.5 : (parseInt(that.allFloorNum / 10) * 0.5) - (i*0.5),
						first: !i ? '1' : `${i}1`
					})
				}
				if (that.allFloorNum % 10) {
					that.allFloorAry.push({
						name: `${parseInt(that.allFloorNum / 10) ? parseInt(that.allFloorNum / 10) : ''}1F - ${parseInt(that.allFloorNum / 10) ? parseInt(that.allFloorNum / 10) : ''}${that.allFloorNum % 10}F`,
						top: 10,
						left: 0,
						first: `${parseInt(that.allFloorNum / 10)}1`
					})
				}
				that.allFloorAry = that.allFloorAry.reverse()
				if (that.allFloorAry.length == 1) {
					that.allFloorAry[0].top = 80
					that.allFloorAry[0].left = 1
				} else if (that.allFloorAry.length == 2) {
					that.allFloorAry[0].top = 45
					that.allFloorAry[0].left = 0.5
					that.allFloorAry[1].top = 80
					that.allFloorAry[1].left = 1
				}
			},
			floorCheck(event) {
				let that = this
				let findIndex = 'noFind';
				for(let i = 0;i < that.indoorMap.length;i++) {
					if (Number(that.indoorMap[i].floor) >= Number(event.first) && Number(that.indoorMap[i].floor) <= Number(event.first)+9) {
						findIndex = i
						break;
					}
				}
				if (findIndex == 'noFind') findIndex = that.indoorMap.length - 1
				that.ifOpen3dIndex = 2
				setTimeout(() => {
					var swiper = new Swiper(".mySwiper", {
						direction: "vertical",
						slidesPerView: 3,
						spaceBetween: 30,
						mousewheel: true,
						initialSlide: findIndex,
						mousewheelControl: true,
						on: {
							click: function(e) {
								if (e.clickedSlide) {
									if (e.clickedSlide.getAttribute('floorID') != 'top' && e.clickedSlide.getAttribute('floorID') != 'bottom') {
										let findObj = that.indoorMap.find(res => res.floor == e.clickedSlide.getAttribute('floorID'))
										that.checkFloor = findObj
										that.setFloorMap(findObj)
									}
								}
							}
						}
					})
				}, 200)
			},
			buildCheck() {
				this.ifOpen3dIndex = 1
			},
			open3D() {
				let maxFloor = [];
				this.indoorMap.map(res => maxFloor.push(Number(res.floor)))
				this.allFloorNum = Math.max.apply(null, maxFloor);
				this.highestFloor()
				this.ifOpen3d = true
				this.ifMapList = false
				this.ifOpen3dIndex = 1
			},
			back3D() {
				this.ifOpen3d = false;
				this.ifOpen3dIndex = 0;
				// this.ifOpen3d = this.ifOpen3dIndex == 1 ? false : true;
				// this.ifOpen3dIndex = this.ifOpen3dIndex - 1;
			},
			drawPointFun (rowInfo) {
				let that = this
				const mapX = Math.sqrt(Math.pow(rowInfo.x, 2));
				const mapOX = Math.sqrt(Math.pow(that.checkFloor.originX, 2));
				let ax = 0;
				if (rowInfo.x == 0) {
					ax = mapOX;
				} else if (rowInfo.x > 0) {
					ax = mapOX + mapX;
				} else if (rowInfo.x < 0) {
					ax = mapOX - mapX;
				}

				const mapH =  that.checkFloor.height * that.checkFloor.resolution;
				const mapY =  Math.sqrt(Math.pow(rowInfo.y, 2));
				const mapOy = Math.sqrt(Math.pow(that.checkFloor.originY, 2));
				let ay = 0;
				if (rowInfo.y == 0) {
					ay = mapY;
				} else if (rowInfo.y > 0) {
					ay = mapH - mapOy - mapY;
				} else if (rowInfo.y < 0) {
					ay = mapH - mapOy + mapY;
				}

				ax = Number(ax / that.checkFloor.resolution);
				ay = Number(ay / that.checkFloor.resolution);
				return [ax, ay]
			},
			mapScroll(type) {
				let leftData = document.getElementsByClassName('mapDom')[0].scrollLeft
				if (type == 'left') {
					document.getElementsByClassName('mapDom')[0].scrollLeft = leftData - 300
				} else {
					document.getElementsByClassName('mapDom')[0].scrollLeft = leftData + 300
				}
			},
			setFloorMap(data) {
				let that = this
				that.back3D()
				that.checkFlvDom = false
				that.checkFloor = data
				that.mapRobotAry = []
				that.checkMapId = data.routeId
				that.backUrl = data.mapUrl
				that.vWidth = Number(data.width)
				that.vHeight = Number(data.height)
				that.computedScaleFloor()
				that.floorNumber = data.floor
				that.indoorRobot.forEach((res, index) => {
					if (res.floor == data.floor) {
						that.mapRobotAry.push(res)
					}
				})
			},
			mapFloorScroll(type) {
				let leftData = document.getElementsByClassName('inFloorDom-center')[0].scrollTop
				if (type == 'left') {
					document.getElementsByClassName('inFloorDom-center')[0].scrollTop = leftData - 30
				} else {
					document.getElementsByClassName('inFloorDom-center')[0].scrollTop = leftData + 30
				}
			},
			toDetail(obj) {
				window.open(window.location.origin + '/#/detail?robotId=' + obj.robotId + '&type=index')
			},
			showMap(data) {
				this.ifEvent = true
				this.evetObj = data
			},
			getRobot(data,index) {
				let that = this
				if (data.onlineStatus == '1') {
					if (that.checkFlvDom) {
						that.checkFlvDom = false
					} else {
						robotDetail(data.robotId).then(res => {
							if (res && res.data) {
								that.checkInfo = res.data
								that.checkFlvDom = true
								that.$nextTick().then(() => {
									// letf-((40 / Number(that.mapScale))) top-((20 / Number(that.mapScale)))
									let flvDomLeft = Number(that.$refs.robot[index].style.left.slice(0, -2));
									let flvDomTop = Number(that.$refs.robot[index].style.top.slice(0, -2));
									let flvDomWidth = document.body.clientWidth * 0.1484;
									let flvDomHeight = document.body.clientHeight * 0.22198;

									that.$refs.flvDom.style.width = 15 / Number(that.mapScale) + "vw"
									that.$refs.flvDom.style.height = 11 / Number(that.mapScale) + "vw"

									// 超出高度
									if (flvDomHeight + flvDomTop * Number(that.mapScale) > document.getElementsByClassName("leftTopUl")[0].offsetHeight) {
										that.$refs.flvDom.style.top = (document.getElementsByClassName("leftTopUl")[0].offsetHeight - (flvDomHeight + 10)) / Number(that.mapScale) + 'px'
									} else {
										that.$refs.flvDom.style.top = flvDomTop  + ((20 / Number(that.mapScale))) + 'px'
									}

									// 超出宽度
									if (flvDomWidth + flvDomLeft* Number(that.mapScale) > document.getElementsByClassName("leftTopUl")[0].offsetWidth) {
										that.$refs.flvDom.style.left = (document.getElementsByClassName("leftTopUl")[0].offsetWidth - (flvDomWidth + 10)) / Number(that.mapScale) + 'px'
									} else {
										that.$refs.flvDom.style.left = flvDomLeft + ((40 / Number(that.mapScale))) + 'px'
									}
									// 适配图标
									that.$refs.zoomSpan.style.zoom = 1 / Number(that.mapScale)
									that.$refs.zoomImage.style.zoom = 1 / Number(that.mapScale)
								})
							}
						})
					}
				} else {
					that.$notify.error({
						title: languageJson.robotNotState
					})
				}
			},
			getMap() {
				let that = this
				tenantInfoMapRoute(getItem('tenantInfoId')).then(res => {
					if (res && res.data.length > 0) {
						that.mapAry = res.data
						that.setCheckMap(res.data[0])
					}
				})
			},
			setCheckMap(info, type) {
				this.back3D()
				this.checkFlvDom = false
				if (info.robotType == '04' || info.robotType == '05' || info.robotType == '06' || info.robotType == '07') {
					this.checkMapNumber = info.routeNumber
					this.checkMapId = info.routeId
					this.robotType = info.robotType
					// this.checkRobotFloor = info.floor
					this.floorNumber = ""
					this.positonList(this.checkMapNumber, type)
				} else {
					this.mapRobotAry = []
					this.checkMapNumber = info.routeNumber
					this.checkMapId = info.routeId
					this.robotType = info.robotType
					this.backUrl = info.routeImg
					this.vWidth = Number(info.width)
					this.vHeight = Number(info.height)
					this.computedScale()
					this.positonList(this.checkMapNumber, type)
				}
			},
			positonList(number, type) {
				let that = this
				positonList({
					number: number,
					userId: getItem('userInfo').staffId
				}).then(resp => {
					if (that.robotType == '04' || that.robotType == '05' || that.robotType == '06' || that.robotType == '07') {
						const getRs = JSON.parse(JSON.stringify(resp.data))
						that.mapRobotAry = []
						that.checkRobotFloor = []
						that.indoorMap = getRs.map.reverse()
						that.indoorRobot = getRs.robotList
						getRs.robotList.map(v => that.checkRobotFloor.push(v.floor))
						const getRsMap = JSON.parse(JSON.stringify(resp.data)).map
						for(let i = 0; i < getRsMap.length;i++) {
							if (that.floorNumber) {
								if (getRsMap[i].floor == that.floorNumber) {
									that.checkFloor = getRsMap[i]
									that.backUrl = getRsMap[i].mapUrl
									that.vWidth = Number(getRsMap[i].width)
									that.vHeight = Number(getRsMap[i].height)
									that.computedScaleFloor()
									that.indoorRobot.forEach((res, index) => {
										if (res.floor == getRsMap[i].floor) {
											that.mapRobotAry.push(res)
										}
									})
									break;
								}
							} else {
								if (Number(getRsMap[i].floor) > 0) {
									that.checkFloor = getRsMap[i]
									that.backUrl = getRsMap[i].mapUrl
									that.vWidth = Number(getRsMap[i].width)
									that.vHeight = Number(getRsMap[i].height)
									that.computedScaleFloor()
									that.indoorRobot.forEach((res, index) => {
										if (res.floor == getRsMap[i].floor) {
											that.mapRobotAry.push(res)
										}
									})
									break;
								}
							}
						}
					} else {
						if (resp && resp.data.robotList.length > 0) {
              that.checkFloor = resp.data.map;
							that.mapRobotAry = []
							resp.data.robotList.forEach(res => {
								// if (res.robotIconStatus != 0) that.mapRobotAry.push(res)
								that.mapRobotAry.push(res)
							})
						} else {
							that.mapRobotAry = []
						}
					}
					if (type == 'click') {
						setTimeout(() => {
							const heightLi = document.getElementsByClassName('inFloorDom-center')[0].offsetHeight / this.indoorMap.length
							const checkFind = this.indoorMap.findIndex(res => res.floor == this.checkFloor.floor)
							document.getElementsByClassName('inFloorDom-center')[0].scrollTop = heightLi*checkFind
						}, 200)
					}
				})
			},
			computedScale() {
				let that = this
				that.mapScale = 1
				that.$nextTick().then(() => {
					if (that.$refs.autoHeight) {
						let oW = that.$refs.autoHeight.offsetWidth
						let oH = that.$refs.autoHeight.offsetHeight
						if (that.vWidth != oW || that.vHeight != oH) {
							let wScale = oW / that.vWidth
							let hScale = oH / that.vHeight
							that.mapScale = Math.min(wScale, hScale);
						}
					}
				})
			},
			computedScaleFloor() {
				let that = this
				that.mapScale = 1
				that.$nextTick().then(() => {
					if (that.$refs.autoHeight) {
						let oW = that.$refs.autoHeight.offsetWidth
						let oH = that.$refs.autoHeight.offsetHeight
						if (Number(that.checkFloor.width) != oW || Number(that.checkFloor.height) != oH) {
							let wScale = oW / Number(that.checkFloor.width)
							let hScale = oH / Number(that.checkFloor.height)
							that.mapScale = Math.min(wScale, hScale);
						}
					}
				})
			},
			changeTap(data) {
				this.tapType = data
			},
			doSocker(socketData) {
				let that = this
				if (socketData.socketType == '1') {
					if (that.checkMapNumber == socketData.map) {
						let mapRobotList = []
						that.mapRobotAry.map(v => {
							mapRobotList.push(v.robotId)
							if (v.robotId == socketData.robotId) {
								v.positon = socketData.positon
							}
						})
						if (mapRobotList.indexOf(socketData.robotId) == -1) {
							that.mapRobotAry.push({
								area: socketData.area,
								floor: socketData.floor,
								map: socketData.map,
								number: socketData.fromUserId,
								positon: socketData.positon,
								robotId: socketData.robotId,
								ststus: socketData.ststus,
								ststusName: socketData.ststusName
							})
						}
					}
					that.mapRobotAry = JSON.parse(JSON.stringify(that.mapRobotAry))
				} else if (socketData.socketType == '2' || socketData.socketType == '4' || socketData.socketType ==
					'6' || socketData.socketType == '7') {
					if (socketData.socketType == '7' && socketData.onlineStatus == '2') {
						that.mapRobotAry.forEach((v, index) => {
							if (v.robotId == socketData.robotId) {
								that.mapRobotAry.splice(index, 1)
							}
						})
						that.mapRobotAry = JSON.parse(JSON.stringify(that.mapRobotAry))
					}
				} else if (socketData.socketType == '22') {
					this.positonList(this.checkMapNumber)
				}
			},
			headOut(data) {
				this.dialogVisible = true
			},
			getOut() {
				removeToken()
				removeItem('differtime')
				removeItem('loginSuccess')
				this.dialogVisible = false
				this.$router.push({
					name: 'login'
				})
			}
		},
		watch: {
			timeStamp: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					if (val) {
						this.computedScale()
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@import "./swiper.css";
	@import "./admin";
</style>



// WEBPACK FOOTER //
// src/page/customIndex/index/index.vue